import React, { useEffect, useState } from "react";
import usePageTitle from "../hooks/usePageTitle";
import PageChrome from "../components/PageChrome";
import Preloader from "../components/Preloader";
import WhyChooseUs from "../components/WhyChooseUs";
import MeetOurTeam from "../components/MeetOurTeam";
import FAQSection from "../components/FAQSection";
import Footer from "../components/Footer";
import CopyRight from "../components/CopyRight";
import CustomerReviews from "../components/CustomerReview";
import MyAboutUS from "../components/MyAboutUS";
import SEOSection from "../components/SEOSection";

const AboutUs = () => {
  usePageTitle("About Us", {
    description:
      "Learn about Dewangan Links — our mission to help the Dewangan community find trusted, verified life partners across India.",
  });

  return (
    <div>
      <PageChrome />
      <section>
        <div className="str">
          <div className="ban-inn ab-ban">
            <div className="container">
              <div className="row">
                <div className="hom-ban">
                  <div className="ban-tit">
                    <span>
                      <i className="no1">#1</i> Wedding Website
                    </span>
                    <h1>About us</h1>
                    <p>
                      Most Trusted and premium Matrimony Service in the World.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <MyAboutUS />

      <CustomerReviews />
      <MeetOurTeam />
      <FAQSection />
      <SEOSection />
      <Footer />
      <CopyRight />
    </div>
  );
};

export default AboutUs;
